import moment from 'moment';
import { EMAIL_CAMPAIGN_STATUS_SENDING, EMAIL_CAMPAIGN_STATUS_SENT } from 'utils/constants';

// Maximum hours since campaign creation to show progress bar
const CAMPAIGN_PROGRESS_VISIBILITY_HOURS = 12;

/**
 * Determines if campaign is currently sending emails
 * @param {Object} campaign - Campaign object
 * @returns {boolean}
 */
export const isCampaignSending = campaign => {
    const inQueue = Number(campaign?.stats2?.in_queue) || 0;
    if (inQueue <= 0) {
        return false;
    }

    if (campaign.status !== EMAIL_CAMPAIGN_STATUS_SENT) {
        return false;
    }

    if (!campaign.created_at) {
        return false;
    }

    // Only show progress bar for campaigns created within the last 12 hours
    const hoursSinceCreated = moment.utc().diff(moment.utc(campaign.created_at), 'hours');
    return hoursSinceCreated <= CAMPAIGN_PROGRESS_VISIBILITY_HOURS;
};

/**
 * Gets the effective status to display (may override actual status with "sending")
 * @param {Object} campaign - Campaign object
 * @returns {string} Status to display
 */
export const getDisplayStatus = campaign => {
    return isCampaignSending(campaign) ? EMAIL_CAMPAIGN_STATUS_SENDING : campaign.status;
};

/**
 * Calculates progress for sending campaigns
 * @param {Object} campaign - Campaign object
 * @returns {Object|null} { sent: number, total: number, formattedText: string } or null
 */
export const getCampaignProgress = campaign => {
    if (!isCampaignSending(campaign)) return null;

    const sent = campaign.recipients_to_count - campaign.stats2.in_queue;
    const total = campaign.recipients_to_count;

    return {
        sent,
        total,
        formattedText: `(${sent} / ${total})`
    };
};
